<script>
import TeaserCard from '@/TeaserCard.vue'
import HighlightedText from '@/components/HighlightedText.vue'

export default {
  components: {
    TeaserCard,
    HighlightedText
  },
  props: {
    imageSrc: {
      type: String,
      required: true
    },
    actionLink: {
      type: String,
      default: null
    },
    btnColor: {
      type: String,
      default: 'btn-outline-primary'
    },
    /**
     * @type {String | VueI18n.TranslateResult}
     */
    headerText: {
      type: String,
      required: true
    },
    /**
     * @type {String | VueI18n.TranslateResult}
     */
    text: {
      type: String,
      required: true
    },
    /**
     * @type {String | VueI18n.TranslateResult}
     */
    btnText: {
      type: String,
      default: null
    }
  }
}
</script>

<template>
  <TeaserCard>
    <template #img>
      <slot name="img">
        <img
          :src="require(`@/assets${imageSrc}`)"
          :alt="headerText"
          class="img-fluid w-100 rounded-top aspect-16by9"
        >
      </slot>
    </template>
    <template #default>
      <div class="text-center">
        <HighlightedText
          :text="headerText"
          class="h4 text-center text-dark"
          tag="h2"
        />
        <p v-t="text"/>
        <slot name="cta">
          <a
            v-if="actionLink && btnText"
            v-track-click="'Teaser Card'"
            :href="actionLink"
            class="btn w-100"
            :class="[btnColor]"
            target="_blank"
          >
            {{ btnText }}
          </a>
        </slot>
      </div>
    </template>
  </TeaserCard>
</template>
